import { Helmet } from "react-helmet-async";

function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto p-6 text-gray-800">
      {/* 🔹 SEO Meta Tags */}
      <Helmet>
        <title>Privacy Policy - Build Pro Resume</title>
        <meta
          name="description"
          content="Learn how Build Pro Resume collects, uses, and protects your personal information. Your privacy matters to us."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* 🔹 Privacy Policy Content */}
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p>
        Your privacy is important to us. This Privacy Policy outlines how we
        collect, use, and protect your personal information when you use{" "}
        <span className="font-semibold">Build Pro Resume</span>.
      </p>

      {/* 🔹 Information Collection */}
      <h2 className="text-xl font-semibold mt-6">📌 Information We Collect</h2>
      <p className="mt-2">
        We may collect personal data, including your name, email address, and
        resume details, to enhance your experience on our platform.
      </p>

      {/* 🔹 Usage of Information */}
      <h2 className="text-xl font-semibold mt-6">
        🔹 How We Use Your Information
      </h2>
      <p className="mt-2">The information we collect is used to:</p>
      <ul className="list-disc list-inside mt-2">
        <li>Improve our resume-building platform</li>
        <li>Provide customer support and assistance</li>
        <li>Personalize your user experience</li>
        <li>Ensure compliance with industry standards</li>
      </ul>

      {/* 🔹 Data Security */}
      <h2 className="text-xl font-semibold mt-6">🔒 Data Security</h2>
      <p className="mt-2">
        We take appropriate security measures to protect your personal
        information from unauthorized access, alteration, or disclosure.
      </p>

      {/* 🔹 Your Rights */}
      <h2 className="text-xl font-semibold mt-6">🔹 Your Rights & Choices</h2>
      <p className="mt-2">
        You have the right to access, update, or request the deletion of your
        personal data. If you have any concerns, feel free to reach out at{" "}
        <span className="text-blue-600 font-semibold">
          support@buildproresume.com
        </span>
        .
      </p>
    </div>
  );
}

export default PrivacyPolicy;
